import React, {useState, useEffect} from 'react';
import { motion } from "framer-motion"
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SingleAddedContact from '../SingleAddedContact'
import {storage, db} from '../../Firebase/firebase'
import { useStore } from '../../StateManagement';
import SingleContactCard from '../SingleContactCard'


function NewGroupParticipantSelection({
  allUsersInDatabase, 
  setAllUsersInDatabase, 
  setShowParticipantMenu, 
  setShowCreateGroupInfo, 
  newSelectedMembers, 
  setNewSelectedMembers
}){
  const [stateData] = useStore();
  const [searchResult, setSearchResult] = useState(allUsersInDatabase);
  const [searchWord, setSearchWord] = useState('');

  // search functionality for adding members to a new group
  const searchContacts = (e) => {
    setSearchWord(e.target.value);
    if(e.target.value.length === 0){
      setSearchResult(allUsersInDatabase)
    }else{
      setSearchResult(allUsersInDatabase.filter(user => user.name.toLowerCase().includes(e.target.value.toLowerCase())))
    }
  }

  return(
    <motion.div 
      className="sidebar__create__participants"
      key="participants"
      animate={{
        x: 0,
        opacity: 1
      }}
      initial={{
        x: -30,
        opacity: 0
      }}
      transition={{duration: 0.5}}
      exit={{
        x: -100,
        opacity: 0
      }}
    >
      <div className="create__participants__container">
        <div className="create__participants__header">
          <ArrowBackIcon onClick={()=> {
            setShowParticipantMenu(false)
            setShowCreateGroupInfo(false)
            }} />
          <h2>Add group participants</h2>
        </div>
        <div className="participants__search">
          <div className="added__contacts">
            {newSelectedMembers.map(person => 
              <SingleAddedContact 
                key={person.uid}
                name={person.name} 
                uid={person.uid} 
                profilePhotoUrl={person.profilePhotoUrl}
                fullDetails={person}
                newSelectedMembers={newSelectedMembers} 
                setNewSelectedMembers={setNewSelectedMembers}
                allUsersInDatabase={allUsersInDatabase}
                setAllUsersInDatabase={setAllUsersInDatabase}
              />)
            }
          </div>
          <input type="search" placeholder="Type contact name" onChange={searchContacts} value={searchWord} />
        </div>
        <div className="contacts">
          {
            searchWord.length > 0 ? searchResult.filter(person => person.uid !== stateData.userDetails.uid).sort((a, b)=> {
              let fa = a.name.toLowerCase(),
                  fb = b.name.toLowerCase();

              if (fa < fb) {
                  return -1;
              }
              if (fa > fb) {
                  return 1;
              }
              return 0;
            }).map(friend => 
              <SingleContactCard 
                key={friend.uid} 
                name={friend.name} 
                about={friend.about} 
                imageUrl={friend.profilePhotoUrl} 
                uid={friend.uid}
                fullDetails={friend}
                newSelectedMembers={newSelectedMembers}
                setNewSelectedMembers={setNewSelectedMembers}
                allUsersInDatabase={allUsersInDatabase}
                setAllUsersInDatabase={setAllUsersInDatabase}
                searchWord={searchWord}
                setSearchWord={setSearchWord}
              />
            ) : allUsersInDatabase.filter(person => person.uid !== stateData.userDetails.uid).sort((a, b)=> {
              let fa = a.name.toLowerCase(),
                  fb = b.name.toLowerCase();

              if (fa < fb) {
                  return -1;
              }
              if (fa > fb) {
                  return 1;
              }
              return 0;
            }).map(friend => 
              <SingleContactCard 
                key={friend.uid} 
                name={friend.name} 
                about={friend.about} 
                imageUrl={friend.profilePhotoUrl} 
                uid={friend.uid}
                fullDetails={friend}
                newSelectedMembers={newSelectedMembers}
                setNewSelectedMembers={setNewSelectedMembers}
                allUsersInDatabase={allUsersInDatabase}
                setAllUsersInDatabase={setAllUsersInDatabase}
              />
            )
          }
        </div>
        <div className="create__group__button">
          <button style={{opacity: newSelectedMembers.length === 0 && '0.5'}} onClick={()=> {
            if(newSelectedMembers.length > 0){
              setShowCreateGroupInfo(true)
            }else{
              alert('add at least one member')
            }
          }}
          >
            <ArrowForwardIcon />
          </button>
        </div>
      </div>
    </motion.div>
  )
}

export default NewGroupParticipantSelection